import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class DictionaryService {
  private dictionary: {[key: string]: string};
  private initSubj = new BehaviorSubject<boolean>(false);

  get initialized(): Observable<boolean> {
    return this.initSubj.asObservable();
  }

  setDictionary(dic: {[key: string]: string}) {
    this.dictionary = dic;
  }

  localize(key: string): string {
    if (this.dictionary) {
      return this.dictionary[key];
    }
    return '';
  }

  localizeAsync(key: string): Observable<string> {
    if (this.dictionary) {
      return of(this.localize(key));
    }
    return this.initSubj.pipe(map(_ => this.localize(key)));
  }
}
